<template>
    <div>
        <div id="loading"  v-if="loading">
            <div class="load-circle text-center" style=" ">
                <div style="text-align: center;">
                    <img :src="empresa.path_file_logo" class="img-fluid" style="text-align: center;">
                </div> 
                <div style="text-align: center;"  class="pt-2 d-inline ">
                        <div role="status" class="spinner-grow text-success spinner-grow-sm  "  >
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div role="status" class="spinner-grow text-success spinner-grow-sm "  >
                            <span class="sr-only">Loading...</span>
                        </div> 
                        <div role="status" class="spinner-grow text-success spinner-grow-sm " >
                            <span class="sr-only">Loading...</span>
                        </div>
                </div>
            </div>
        </div>

        <!-- ======= Top Bar ======= -->
        <section id="topbar" :class="['d-none', 'd-lg-block', 'tolbarColorX']">
            <div :class="['container', 'clearfix']">
                <div  v-for="(val, key) in empresa.sucursales" :key="key" >
                    <div :class="['contact-info', 'float-left', 'fuente14', 'colorWhite', 'mr-4']">
                        <i :class="['icofont-google-map']"></i> {{val.direccion}}
                    </div>
                </div>

                <div :class="['contact-info', 'float-left', 'fuente14', 'colorWhite', 'mr-4']">
                    <i :class="['icofont-email']"></i> {{empresa.email}}
                </div>
            </div>
        </section>

        <!-- ======= Header ======= -->
        <header id="header">
            <div :class="['container']">
                <div :class="['logo', 'float-left']">      
                    <router-link :to="'/'">
                        <img :src="empresa.path_file_logo" :alt="empresa.abreviatura" :class="['img-fluid', 'imgLogo']" />
                    </router-link>
                </div>

                <nav :class="['nav-menu', 'float-right', 'd-none', 'd-lg-block']">
                    <ul>
                        <li :class="[($route.name=='/')?'active':'']"><router-link :to="'/'"><i :class="['icofont-home', 'mr-1']"></i>INICIO</router-link></li>
                        <li :class="[($route.name=='Nostros')?'active':'']">
                            <a href="https://www.gob.pe/institucion/regionsanmartin-dra/institucional" target="_blank"><i :class="['icofont-institution', 'mr-1']"></i>INSTITUCIÓN</a>
                        </li>
                        <li :class="[($route.name=='Agencias')?'active':'']"><router-link :to="'/agencias'"><i :class="['icofont-map-pins', 'mr-1']"></i>AGENCIAS</router-link></li>
                        <li :class="[($route.name=='transparencia')?'active':'']">
                            <a href="http://www.transparencia.gob.pe/enlaces/pte_transparencia_enlaces.aspx?id_entidad=13270&id_tema=5&ver=D" target="_blank">
                                <img width="140px" height="40px" src="/img/Transparencia.png">
                            </a>
                        </li>
                        <li :class="[($route.name=='Directorio')?'active':'']"><a target="_blank" href="https://www.gob.pe/institucion/regionsanmartin-dra/funcionarios"><i :class="['icofont-institution', 'mr-1']"></i>DIRECTORIO</a></li>
                        <li :class="[($route.name=='Contactenos')?'active':'']"><a target="_blank" href="https://www.gob.pe/institucion/regionsanmartin-dra/contacto-y-numeros-de-emergencias"><i :class="['icofont-ui-contact-list', 'mr-1']"></i>CONTACTO</a></li>
                    </ul>
                </nav>
            </div>
        </header>
        <!-- End Header -->
    </div>
</template> 

<script>
    import {mapState} from 'vuex';

    export default {
        name:'ToolBar',
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
    }
</script>